/**
* Component: BasicDetails.jsx
* Description: This component is utilized for creating and updating the basic details of the asset.
*/

import { Box, Grid, Typography, debounce } from "@mui/material";
import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearAttachmentDetails, gridValues, mandatoryFields, serviceType, updateAssetSpecification, updateBasicDetails, updatePurchaseDetails, } from "../../redux/actions/assetActions";
import BottomButtons from "../commoncomponents/BottomButtons";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import { getAuthToken, getFacilityId, getModifiedBy, getcompanyId } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import assetCreateUpdateRepository from "../../api/repositories/assetCreateUpdateRepository";
import AssetRepository from "../../api/repositories/assetRepository";
import { validations } from "../../utility/constants/errors/messages";
import utils from "../../utility/utilities";
import dayjs from "dayjs";
import PageLoader from "../commoncomponents/PageLoader";
import { useLocation, useNavigate } from "react-router-dom";

const BasicDetails = ({ setPage, page, buttonAttributes }) => {

  const dispatch = useDispatch();

  //To get the URL path to classfy the Asset type
  const url = window.location.pathname;
  const getfemorbemURL = url?.split('/').includes('assetsFEM') ? '/assetsFEM' : '/assetsBEM';

  //getting the mandatoryBasicDetils form state for displying the reqired filed is filed on the left card
  const mandatoryBasicDetails = useSelector(
    (state) => state.mandatoryFields.mandatoryFieldsBasicDetails
  );

  //get the mandatory fileds for asset specification
  const assetSpecificationMandatoryFields = useSelector(
    (state) => state.mandatoryFields.mandatoryFieldsAssetSpecification
  );

  //get the mandatory fields for purchase warrenty
  const purchaseWarrentyMandatoryFields = useSelector(
    (state) => state.mandatoryFields.mandatoryFieldsPurchaseDetails
  );

  //state to check user choose to edit
  const selectedGridData = useSelector(
    (state) => state.gridValues.selectedGridData
  );

  //getting the basicDetails values form redux
  const basicDetails = useSelector(
    (state) => state.basicDetails
  );

  //get the purchase details form redux
  const purchaseDetails = useSelector(
    (state) => state?.purchaseDetails
  );

  //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
  const findHeaderContent = buttonAttributes.find(
    (item) => item.currentPageName === page
  );

  //get the facility id from local storage
  const facilityId = getFacilityId('facilityId');

  //get the company id from local storage
  const companyId = getcompanyId('companyId');

  //assigning rentalStatus option values(static)
  const rentalStatusOptionsdd = [
    { label: "Yes", key: "option1", default: false },
    { label: "No", key: "option2", default: true },
  ];

  //assigning ppmRequiredoption values(static)
  const ppmRequiredOptionsdd = [
    { label: "Yes", key: "option1", default: true, id: 1 },
    { label: "No", key: "option2", default: false, id: 2 },
  ];


  //state that acts as a flag for showing error(red) box while validation
  const [error, setError] = useState({
    assetDescription: false,
    typecode: false,
    rentalStatus: false,
    departmentDescription: false,
    locationName: false,
    assetClassification: false,
    workGroup: false,
    ppmRequired: false,
    ppmStatus: false,
    reason: false,
    medicalequipmentcategory: false
  }) //state includes only required fileds

  //state used to display error message while validating the fields
  const [errorMessage, setErrorMessage] = useState({
    assetDescription: '',
    typecode: '',
    rentalStatus: '',
    departmentDescription: '',
    locationName: '',
    assetClassification: '',
    workGroup: '',
    ppmRequired: '',
    ppmStatus: '',
    reason: '',
    medicalequipmentcategory: ''
  }); //state includes only required fileds

  //state that holds all input datas
  const [basicDetailsdata, setBasicDetailsdata] = useState({ ...basicDetails } ||
  {
    rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
    tcNo: '',
    tcOldNo: '',
    assetClassification: { key: 'option1', id: 1, label: 'Asset', isloanerasset: false }, //setting the default value for asset classification when rentalStatus is No
    financeAssetNo: '',
    assetDescription: '',
    typecode: '',
    typeCodeDescription: '',
    locationName: '',
    locationNo: '',
    userDepartment: '',
    departmentDescription: '',
    criticality: '',
    workGroup: '',
    ppmRequired: { label: "Yes", key: "option1", default: true },//setting the default value
    ppmStatus: { label: "In House", key: "option2", id: 2, isvisible: true }, //setting the default value
    parentAssestNo: '',
    description: '',
    reason: '',
    isauthorized: false,
    assetValue: '',
    oldAssetNo: "",
    medicalequipmentcategory: { label: "", value: "", id: "" },
  }
  );

  const [serviceId, setServiceId] = useState('');
  const [hospitalId, setHospitalId] = useState('');

  const assetCategoryType = getfemorbemURL;
  const assetType = assetCategoryType === "/assetsFEM" ? FemsGraph : BemsGraph;
  let toGetServiceId = ''
  //state that hold all options values for input fileds
  const [basicDetailsOptions, setBasicDetailsOptions] = useState(
    {
      rentalStatusOptions: rentalStatusOptionsdd,
      assetClassificationOptions: [],
      typeCodeOptions: [],
      locationNameOptions: [],
      ppmRequiredOptions: ppmRequiredOptionsdd,
      typeCodeDescriptionOptions: [],
      criticalityOptions: [],
      ppmStatusOptions: [],
      workGroupOptions: [],
      parentAssetOptions: [],
      tcNoOptions: [],
      medicalEquipmentCategoryOptions: []
    }
  );

  //state to check all maditory fields are filled
  const [isFilledAllMandatoryField, setIsFilledAllMandatoryField] = useState(false);
  const [initialBasicDetailsdata, setInitialBasicDetailsdata] = useState({});
  const [isDataChanged, setIsDataChanged] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  //state for pageLoader
  const [isLoading, setIsLoading] = useState(false);

  //state for parentAssetNo for setting dynamic api approach
  const [parentAssetNo, setParentAssetNo] = useState('');

  const setParentAssetNoOptions = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${getAuthToken("id_token")}`, // Example: Retrieve token from localStorage
      },
    };
    if (parentAssetNo !== "" && parentAssetNo !== undefined) {
      try {
        // setIsLoading(true);
        const parentAssestNoOptions = await axios.get(`${assetType}/api/GraphAssetRegister/GetParentAssetNobyFacilityId/${facilityId}/${parentAssetNo}?size=10000`, config);
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          parentAssetOptions: parentAssestNoOptions?.data?.map((item, index) => ({
            key: `option-${index}`,
            id: item?.id,
            label: `${item?.assetno} - ${item?.assetdesc}`,
            code: item?.assetno,
            assetdesc: item?.assetdesc
          })),
        }));
      } catch (error) {
        console.log("Failed to fetch asset data:", error);
      } finally {
        // setIsLoading(false);
      }
    }
  };

  // Service ID
  const getServiceId = async (id) => {
    try {
      const url = window.location.pathname;
      const urlArray = url.split("/");
      const femorBem = urlArray?.includes("assetsFEM") ? "/assetsFEM" : "/assetsBEM";
      const response = await AssetRepository.workGroupCodeDetails(femorBem, id);
      setServiceId(response[0]?.serviceid);
      toGetServiceId = response[0]?.serviceid || ""
    } catch (error) {
      console.log("Failed to fetch asset data:", error);
    }
  };

  const getAssetTypeCodeOptions = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${getAuthToken("id_token")}`, // Example: Retrieve token from localStorage
      },
    };

    try {
      const assetClassificationId = basicDetailsdata?.assetClassification?.id;
      const companyId = getcompanyId();
      if (!assetClassificationId) return;
      const femorbems = assetCategoryType === "/assetsFEM" ? 'GetFemassettypecode' : 'GetBemassettypecode';
      const assetTypeCodeOptions = await axios.get(`${assetType}/api/GraphAssetregister/${femorbems}/${companyId}/${serviceId}/${assetClassificationId}`, config);
      setBasicDetailsOptions((prevOptions) => ({
        ...prevOptions,
        typeCodeDescriptionOptions: assetTypeCodeOptions?.data?.map((item, index) => ({
          key: `option-${index}`,
          id: item?.id,
          label: `${item?.typecode} - ${item?.typedescription}`,
          value: item?.typecode,
          desc: item?.typedescription
        })),
      }));
    } catch (error) {
      console.log("Failed to fetch asset data:", error);
    }
  }

  //set parentAssetNo options when parentAssetNo changes
  useEffect(() => {
    setParentAssetNoOptions();
    if (serviceId && basicDetails?.assetClassification?.id) {
      getAssetTypeCodeOptions();
    }
  }, [parentAssetNo, basicDetails?.assetClassification?.id, serviceId]);

  const fetchOptions = async () => {

    try {
      setIsLoading(true);
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const tcOptions = await axios.get(`${assetType}/api/TestingandCommission/GetTestingCommissionLookup/${facilityId}`, config);
      setBasicDetailsOptions((prevOptions) => ({
        ...prevOptions,
        tcNoOptions: tcOptions?.data?.map((item, index) => ({
          ...item,
          id: item?.id,
          label: item?.testingcommissionno,
          value: item?.testingcommissionno
        }))
      }))


    } catch (err) {
      console.log(err);
    }
    if (assetCategoryType === "/assetsBEM") {

      try {
        setIsLoading(true);
        const token = getAuthToken("id_token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const medicalOptions = await axios.get(`${assetType}/api/bemmedicalequipmentcategories`, config);
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          medicalEquipmentCategoryOptions: medicalOptions?.data?.map((item, index) => ({
            ...item,
            id: item?.id || "",
            label: item?.medicalequipmentcategory || "",
            value: item?.medicalequipmentcategory || ""
          }))
        }))


      } catch (err) {
        console.log(err);
      }
    }

    try {
      const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Attach bearer token to request header
        },
      };
      //make nested try catch for error handling and dynamic API calls
      // Hospital Code for Asset Number
      try {
        const hospitalCodeForAssetNo = await axios.get(
          `${assetType}/GetHospitalcodebyFacilityid/${facilityId}`,
          config
        );
        setHospitalId(hospitalCodeForAssetNo?.data[0]?.id);
      } catch (error) {
        console.log("Failed to fetch hospital code:", error);
      };

      getServiceId(facilityId);

      // Set initial asset value
      const assetValue = selectedGridData?.values?.assetno || selectedGridData?.values?.assetNo;
      setBasicDetailsdata((previousValue) => ({
        ...previousValue,
        assetValue: assetValue
      }));

      // Options for asset classification
      try {
        let assetClassification = {};
        if (assetType === FemsGraph) {
          assetClassification = await axios.get(`${FemsGraph}/api/femassetclassifications`, config);
        } else {
          assetClassification = await axios.get(`${BemsGraph}/api/bemassetclassifications`, config);
        }

        const assetClassificationOptions = assetClassification?.data?.map((item) => ({
          key: `option${item.id}`,
          id: item.id,
          label: item?.assetclassification,
          isloanerasset: item?.isloanerasset,
          isvisible: item?.isvisible
        }));

        if (selectedGridData?.isEdit) {
          setParentAssetNo(basicDetailsdata?.assetClassification?.id);
        } else {
          const findParentAsset = assetClassificationOptions?.find((item) => item?.label === "Asset");
          setParentAssetNo(findParentAsset?.id);
        }

        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          assetClassificationOptions,
        }));
      } catch (error) {
        console.log("Failed to fetch asset classification options:", error);
      }

      // Asset Options
      try {
        const locationOptions = await axios.get(`${MasterGraph}/api/CommonExport/CommonExportData/${facilityId}/Location?filterOptions=[]&sortOptions=[]`, config);



        // Location Name Options
        const locationNameOptions = locationOptions?.data?.userLocationVMs?.map((item, index) => ({
          id: item?.id,
          key: `option${index}`,
          label: `${item?.locationcode} - ${item?.locationdesc}`,
          value: item?.locationcode,
          desc: item?.locationdesc,
          userDepartment: item?.departmentcode,
          departmentDescription: item?.departmentdesc
        }));
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          locationNameOptions,
        }));
      } catch (error) {
        console.log("Failed to fetch asset options:", error);
      }

      if (basicDetailsdata?.isTCField) {
        const setTypeCodeDescription = basicDetailsdata?.typeCodeDescription;
        const setLocation = basicDetailsdata?.locationName;
        const setTcNo = basicDetailsdata?.tcNo;
        setBasicDetailsdata((previousValue) => ({
          ...previousValue,
          typeCodeDescription: setTypeCodeDescription?.id ? setTypeCodeDescription : '',
          locationName: setLocation?.id ? setLocation : '',
          tcNo: setTcNo?.id ? setTcNo : '',
          isTCField: false
        }))
      }

      // Workgroup Options
      try {
        const workgroupOptions = await axios.get(`${assetType}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=10000`, config);
        const wgOptionsSorting = workgroupOptions.data?.sort((a, b) => {
          const matchWgCode = a.wgcode?.match(/\d+/); // Check the work group code 
          const matchWgDescription = b.wgcode?.match(/\d+/); // check the workgroupdescription 
          const wgCode = matchWgCode ? parseInt(matchWgCode[0], 10) : Number.MAX_SAFE_INTEGER; // Assign a high value if no digits
          const wgDescription = matchWgDescription ? parseInt(matchWgDescription[0], 10) : Number.MAX_SAFE_INTEGER; // Assign a high value if no digits
          return wgCode - wgDescription;
        }).map((item, index) => ({
          key: `option${index}`,
          id: item?.id,
          label: item?.wgcode + " - " + item?.wgdesc,
          code: item?.wgcode,
          desc: item?.wgdesc
        }));

        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          workGroupOptions: wgOptionsSorting
        }));
      } catch (error) {
        console.log("Failed to fetch workgroup options:", error);
      }

      // Criticality and PPM Status Options
      try {
        const PPMandCriticalOptions = await axios.get(`${assetType}/api/CommonLov/GetCommonLovList?size=10000`, config);
        const femOrBem = assetType === FemsGraph ? "fem" : "bem";
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          criticalityOptions: PPMandCriticalOptions.data[`${femOrBem}assetcriticalities`]?.map((item) => ({
            key: `option${item?.id}`,
            label: item?.assetcriticality,
            isvisible: item?.isvisible,
            id: item?.id
          })),
          ppmStatusOptions: PPMandCriticalOptions.data[`${femOrBem}assetppmstatuses`]?.filter((item) => item?.id !== 3)
            ?.map((item) => ({
              key: `option${item?.id}`,
              label: item?.ppmstatus,
              isvisible: item?.isvisible,
              id: item?.id
            })),
        }));
      } catch (error) {
        console.log("Failed to fetch criticality and PPM status options:", error);
      }

    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);

    }
  };

  const fetchEditOptions = async () => {

    setIsLoading(true);
    const checkFemorBem = assetType === FemsGraph ? "fem" : "bem";
    //set the values and options
    const locationId = selectedGridData?.values?.userlocationid;
    const locationCode = selectedGridData?.values?.userLocationCode;
    const deptCode = selectedGridData?.values?.userDepartmentCode;
    const deptDesc = selectedGridData?.values?.userDescription;
    const locationDesc = selectedGridData?.values?.locationdesc;
    const typecodeId = selectedGridData?.values?.typecodeid;
    const getPPMRequired = selectedGridData?.values?.isppmrequiredflag;
    const ppmRequired = getPPMRequired === true ? { key: "option1", label: "Yes" } : { key: "option2", label: "No" };
    const reason = selectedGridData?.values?.reason;
    const assetDescription = selectedGridData?.values?.assetdesc;
    const isLonerAsset = selectedGridData?.values?.isloanerasset;
    const oldassetno = selectedGridData?.values?.oldassetno;
    const financeAssetNo = selectedGridData?.values?.finanaceassetno;
    const isAuthorized = selectedGridData?.values?.isauthorized;
    const tcid = selectedGridData?.values?.femtestingandcommissionId || selectedGridData?.values?.bemtestingandcommissionId;
    const tcLabel = selectedGridData?.values?.testingandcommissionvalue;
    const tcNo = { label: tcLabel || '', key: tcLabel || '', id: tcid };
    const assetValue = selectedGridData?.values?.assetno || selectedGridData?.values?.assetNo || "";
    const medicalequipmentcategory = selectedGridData?.values?.bemmedicalequipmentcategoryId === 0 ? { label: "", value: "", id: "" } : {
      key: `option${selectedGridData?.values?.bemmedicalequipmentcategoryId}`,
      label: selectedGridData?.values?.medicalequipmentcategory || "",
      value: selectedGridData?.values?.medicalequipmentcategory || "",
      id: selectedGridData?.values?.bemmedicalequipmentcategoryId || ""
    };

    // const tcOldNo= selectedGridData?.values?.testcommissionoldid; //need to review
    const assetClassificationName = selectedGridData?.values?.assetClassificationCode;
    const criticalityId = selectedGridData?.values?.criticality;
    // const ppmStatusId = selectedGridData?.values?.femassetppmstatusId;
    const ppmStatusId = selectedGridData?.values?.[`${checkFemorBem}assetppmstatusId`];
    const tcOldId = selectedGridData?.values?.testcommissionoldno;
    const parentAssetId = selectedGridData?.values?.parentassetid;
    // const workgroupId=selectedGridData?.values?.femassetpurchasecostflag?.femassetregisters[0]?.femworkgroupdetails?.wgcode;
    const workgroupId = selectedGridData?.values?.workgroup;
    //function to get the location name,user department and department description based on locationId

    try {
      const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Attach bearer token to request header
        },
      };

      //find the assetClassification based on assetClassificationId
      let assetClassificationOptions = {};
      if (assetType === FemsGraph) {
        try {
          assetClassificationOptions = await axios.get(
            `${FemsGraph}/api/femassetclassifications`, config
          );
        } catch (err) {
          console.log(err);
        }

      } else {
        try {
          assetClassificationOptions = await axios.get(
            `${BemsGraph}/api/bemassetclassifications`, config
          );
        } catch (err) {
          console.log(err);
        }
      }



      let workgroupOptions = {};
      try {
        workgroupOptions = await axios.get(`${assetType}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=10000`, config);
      } catch (error) {
        console.log(error);
      }
      const workGroupdata = workgroupOptions.data?.find((item) => item?.wgcode === workgroupId);
      const workGroup = { id: workGroupdata?.id, key: `option`, label: workGroupdata?.wgcode, desc: workGroupdata?.wgdesc, code: workGroupdata?.wgcode };

      let response = {};
      try {
        response = await axios.get(`${assetType}/api/CommonLov/GetCommonLovList?size=10000`, config);
      } catch (error) {
        console.log(error);
      }
      const criticalityoption = response?.data?.[`${checkFemorBem}assetcriticalities`]?.find((item) => item?.id === criticalityId);
      let criticality = {};
      try {
        criticality = { key: `option${criticalityoption?.id}`, label: criticalityoption?.assetcriticality, isvisible: criticalityoption?.isvisible, id: criticalityoption?.id };
      } catch (error) {
        console.log(error);
      }
      const ppmStatusoption = response?.data?.[`${checkFemorBem}assetppmstatuses`]?.find((item) => item?.id === ppmStatusId);
      const ppmStatus = { key: `option${ppmStatusoption?.id}`, label: ppmStatusoption?.ppmstatus, isvisible: ppmStatusoption?.isvisible, id: ppmStatusoption?.id };
      const assetClassificationoption = assetClassificationOptions?.data?.find((item) => item?.assetclassification === assetClassificationName);
      const assetClassification = { key: `option${assetClassificationoption?.id}`, label: assetClassificationoption?.assetclassification, isvisible: assetClassificationoption?.isvisible, id: assetClassificationoption?.id };

      const assetClassificationId = assetClassificationoption?.id || "";

      //need to remove the pagination size once the api pagination functionality is ready
      let parentAssestNoOptions = {};
      try {
        if (assetClassificationId) {
          parentAssestNoOptions = await axios.get(`${assetType}/api/GraphAssetRegister/GetParentAssetNobyFacilityId/${facilityId}/${assetClassificationId}?size=10000`, config);
        }
      } catch (err) {
        console.log(err);
      }
      const getparentAsset = parentAssestNoOptions?.data?.find((item) => item?.id === parentAssetId);
      const parentAsset = { id: getparentAsset?.id, key: `option`, label: `${getparentAsset?.assetno}`, assetno: getparentAsset?.assetno, assetdesc: getparentAsset?.assetdesc };
      //For Parent Asset Options Just set the parentAssetId 
      setParentAssetNo(assetClassification?.id)

      let typeCodeOptions = [];
      let locationOptions = [];

      const checkService = assetCategoryType === "/assetsFEM" ? "GetFemassettypecode" : "GetBemassettypecode";

      try {
        locationOptions = await axios.get(`${MasterGraph}/api/CommonExport/CommonExportData/${facilityId}/Location?filterOptions=[]&sortOptions=[]`, config);
        if (assetClassificationId) {
          typeCodeOptions = await axios.get(`${assetType}/api/GraphAssetregister/${checkService}/${companyId}/${toGetServiceId}/${assetClassificationId}`, config);
        }
      } catch (err) {
        console.log(err);
      }

      const typeCodeDescription = typeCodeOptions?.data?.map((item, index) => ({
        id: item?.id,
        key: `option${index}`,
        label: `${item?.typedescription}`,
        value: item?.typecode
      }));

      const getTypeCodeDescription = (typecodeId) => {

        const typecode = typeCodeDescription?.find((item) => item?.id === typecodeId);

        return typecode;
      };

      const typecodeDetails = getTypeCodeDescription(typecodeId);

      const locationNameOptions = locationOptions?.data?.userLocationVMs?.map((item, index) => ({
        id: item?.id,
        key: `option${index}`,
        label: `${item?.locationdesc}`,
        value: item?.locationcode,
        desc: item?.locationdesc,
        userDepartment: item?.departmentcode,
        departmentDescription: item?.departmentdesc
      }));




      const getLocationName = (locationId) => {
        const location = locationNameOptions?.find((item) => item?.id === locationId);
        return location;
      };

      const locationDetails = getLocationName(locationId);

      const locationDetailsFromAPIResponse = {
        id: locationId || "",
        key: `option1`,
        label: `${locationDesc}` || "",
        value: locationCode || "",
        desc: locationDesc || "",
        userDepartment: deptCode || "",
        departmentDescription: deptDesc || ""
      };

      setInitialBasicDetailsdata({
        ...basicDetailsdata,
        tcNo: tcid ? tcNo : "",
        assetValue: assetValue ? assetValue : "",
        rentalStatus: isLonerAsset ? { label: "Yes", key: "option1", default: false } : { label: "No", key: "option2", default: true },
        typeCodeDescription: typecodeDetails?.id ? { ...typecodeDetails } : "",
        locationName: locationDetails?.id ? { ...locationDetails } : locationDetailsFromAPIResponse,
        ppmRequired: { ...ppmRequired },
        reason: reason ? reason : "",
        assetDescription: assetDescription ? assetDescription : "",
        assetClassification: assetClassification?.id ? assetClassification : "",
        criticality: criticality?.id ? criticality : "",
        ppmStatus: ppmStatus?.id ? ppmStatus : { label: "In House", key: "option2", isvisible: true, id: 2 },
        tcOldNo: tcOldId ? tcOldId : "",
        parentAssestNo: parentAsset?.id ? parentAsset : "",
        workGroup: workGroup?.id ? workGroup : "",
        oldAssetNo: oldassetno ? oldassetno : "",
        financeAssetNo: financeAssetNo ? financeAssetNo : "",
        isauthorized: isAuthorized ? isAuthorized : false,
        medicalequipmentcategory: medicalequipmentcategory?.id === 0 ? { label: "", value: "", id: "" } : medicalequipmentcategory,
      })
      setBasicDetailsdata((previousValue) => {
        return {
          ...previousValue,
          tcNo: tcid ? tcNo : "",
          rentalStatus: isLonerAsset ? { label: "Yes", key: "option1", default: false } : { label: "No", key: "option2", default: true },
          typeCodeDescription: typecodeDetails?.id ? { ...typecodeDetails } : "",
          locationName: locationDetails?.id ? { ...locationDetails } : locationDetailsFromAPIResponse,
          ppmRequired: { ...ppmRequired },
          reason: reason ? reason : "",
          assetDescription: assetDescription ? assetDescription : "",
          assetClassification: assetClassification?.id ? assetClassification : "",
          criticality: criticality?.id ? criticality : "",
          ppmStatus: ppmStatus?.id ? ppmStatus : { label: "In House", key: "option2", isvisible: true, id: 2 },
          tcOldNo: tcOldId ? tcOldId : "",
          parentAssestNo: parentAsset?.id ? parentAsset : "",
          workGroup: workGroup?.id ? workGroup : "",
          oldAssetNo: oldassetno ? oldassetno : "",
          financeAssetNo: financeAssetNo ? financeAssetNo : "",
          isauthorized: isAuthorized ? true : false,
          medicalequipmentcategory: medicalequipmentcategory?.id === 0 ? { label: "", value: "", id: "" } : medicalequipmentcategory,
        }
      });

    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Edit the Asset listing page
  const viewAssetApi = async (id, url) => {
    try {
      const response = await AssetRepository.assetViewDetail(
        url,
        id
      );
      return response;
    } catch (error) {
      console.log("Fail to get the asset", error);
    }
  };

  const handleEdit = async (assetId, type, url) => {
    if (type !== 'Edit') return;
    let Edit = type === "Edit" ? true : false;
    try {
      const editAssetbyId = await viewAssetApi(assetId, url);
      const isAssetCreation = false; //this flag for not showing the underwarranty
      const mergerowData = { ...editAssetbyId, timestamp: location?.state?.timestamp || "" }
      const mergedPurchaseDetails = { ...purchaseDetails, isAssetCreation, lastUnscheduledWorkOrder: mergerowData?.lastunscheduledworkorder || "", lastScheduledWorkOrder: mergerowData?.lastscheduledworkorder || "", conditioncategory: mergerowData?.conditioncategory || "" };

      if (editAssetbyId) {
        dispatch(gridValues({ values: mergerowData, isEdit: Edit, isView: !Edit }));
        dispatch(updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails));
      } else {
        // setIsError(true)
      }
    } catch (error) {
      console.log("Fail to get the asset", error);
    }
  };

  const mode = location.state?.type;

  useEffect(() => {
    const url = window.location.pathname;
    const urlArray = url.split("/");
    const assetId = location.state?.id;

    if (urlArray?.includes('assetsFEM')) {
      dispatch(serviceType('/assetsFEM'));
      handleEdit(assetId, mode, '/assetsFEM');

    } else if (urlArray?.includes('assetsBEM')) {
      dispatch(serviceType('/assetsBEM'));
      handleEdit(assetId, mode, '/assetsBEM');
    }
    dispatch(serviceType(getfemorbemURL)); //to prevent the refresh issue
  }, []);

  useEffect(() => {
    const fetchdata = async () => {
      setIsLoading(true);
      await fetchOptions();
      if (selectedGridData?.isEdit && !basicDetailsdata?.typeCodeDescription && !basicDetailsdata?.locationName) {
        getServiceId(facilityId)
        await fetchEditOptions();
        setIsLoading(false);
        //the conditon is simple when the isEdit is true and the basicDetailsdata.typeCodeDescription and basicDetailsdata.locationName is null
        //this is rendering when user goes to next page and comes back again it renders so i have added two conditons extra
      } else if (selectedGridData?.isEdit && basicDetailsdata?.typeCodeDescription && basicDetailsdata?.locationName) {
        //set the initial values
        setInitialBasicDetailsdata({ ...basicDetailsdata });
        setIsLoading(false);
      }
    };
    fetchdata();

  }, [selectedGridData?.isEdit]);


  const memoizedDetails = useMemo(() => ({
    rentalStatus: basicDetailsdata?.rentalStatus || '',
    assetClassification: basicDetailsdata?.assetClassification || '',
    assetDescription: basicDetailsdata?.assetDescription || '',
    typeCodeDescription: basicDetailsdata?.typeCodeDescription || '',
    locationName: basicDetailsdata?.locationName || '',
    workGroup: basicDetailsdata?.workGroup || '',
    ppmRequired: basicDetailsdata?.ppmRequired || '',
    ppmStatus: basicDetailsdata?.ppmStatus || '',
    reason: basicDetailsdata?.reason || '',
    ...(assetCategoryType === "/assetsBEM" && {
      medicalequipmentcategory: basicDetailsdata?.medicalequipmentcategory || ''
    })
  }), [
    basicDetailsdata?.rentalStatus,
    basicDetailsdata?.assetClassification,
    basicDetailsdata?.assetDescription,
    basicDetailsdata?.typeCodeDescription,
    basicDetailsdata?.locationName,
    basicDetailsdata?.workGroup,
    basicDetailsdata?.ppmRequired,
    basicDetailsdata?.ppmStatus,
    basicDetailsdata?.reason,
    basicDetailsdata?.medicalequipmentcategory,
  ]);

  const checkTextBoxValue = (value) => {
    const pattern = /^(?! )[a-zA-Z0-9,!@#$%&*()_-]+(?: [a-zA-Z0-9,!@#$%&*()_-]+)* ?$/
    if (pattern.test(value)) {
      return true;
    } else {
      return false
    }
  };

  //function to check the mandatory field are filled or not(responsible for green ticks on left side)
  const checkMandatoryValueFilled = useCallback(debounce((
    rentalStatus,
    assetClassification,
    assetDescription,
    typeCodeDescription,
    locationName,
    workGroup,
    ppmRequired,
    ppmStatus,
    medicalequipmentcategory,
    reason
  ) => {
    const updateStatus = (type, value, name, isVisible) => ({
      type, valueFilled: !!value, name, isVisible
    });

    const updaterentalStatus = updateStatus("Service Type", rentalStatus, 'rentalStatus', true);
    const updateassClassification = updateStatus("Asset Classification", assetClassification, 'assetClassification', true);
    const updateassetDescription = updateStatus("Asset Description", checkTextBoxValue(assetDescription), 'assetDescription', true);
    const updatetypeCodeDescription = updateStatus("Type Code Description", typeCodeDescription?.id, 'typeCodeDescription', true);
    const updatelocationName = updateStatus("Location Name", locationName?.id, 'locationName', true);
    const updateworkGroup = updateStatus("Work Group", workGroup?.id, 'workGroup', true);
    const updateppmRequired = updateStatus("PPM Required", ppmRequired, 'ppmRequired', true);
    const updateppmStatus = updateStatus("PPM Status", ppmStatus, 'ppmStatus', true);
    const updatemedicalequipmentcategory = updateStatus("Medical Equipment Category", medicalequipmentcategory?.id, 'medicalequipmentcategory', assetCategoryType === "/assetsBEM" ? true : false);

    let updatereason;
    if (ppmRequired?.label === 'No') {
      updatereason = updateStatus("Reason", reason && reason.trim(), 'reason', true);
    } else {
      updatereason = { type: "Reason", valueFilled: false, name: 'reason', isVisible: false };
    }

    const arrayAfterUpdating = [
      updateassClassification,
      updaterentalStatus,
      updateassetDescription,
      updatetypeCodeDescription,
      updatelocationName,
      updateworkGroup,
      updateppmRequired,
      updateppmStatus,
      updatemedicalequipmentcategory,
      updatereason
    ];

    if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
      dispatch(mandatoryFields(arrayAfterUpdating, "UPDATE_BASIC_DETAILS_MANDATORY_FIELDS"));
    }
  }), [dispatch]);

  useEffect(() => {
    const {
      rentalStatus,
      assetClassification,
      assetDescription,
      typeCodeDescription,
      locationName,
      workGroup,
      ppmRequired,
      ppmStatus,
      medicalequipmentcategory,
      reason
    } = memoizedDetails;

    checkMandatoryValueFilled(
      rentalStatus,
      assetClassification,
      assetDescription,
      typeCodeDescription,
      locationName,
      workGroup,
      ppmRequired,
      ppmStatus,
      medicalequipmentcategory,
      reason
    );
  }, [
    memoizedDetails,
    checkMandatoryValueFilled
  ]);

  const generateAssetNo = async (assetClassificationId) => {
    if (assetClassificationId && hospitalId && serviceId) {
      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken("id_token")}`, // Example: Retrieve token from localStorage
        },
      }
      try {
        const assetNoGeneration = await axios.get(`${assetType}/api/GraphAssetregister/GetAssetNoGenerateAsync/${hospitalId}/${assetClassificationId}/${serviceId}`, config);
        return assetNoGeneration?.data?.assetno;
      } catch (error) {
        console.log("Failed to fetch asset data:", error);
        return '';
      }
    }
  };

  const clearAutoFetchedTCDetails = () => {
    //set initial
    const intialBaiscDetails = {
      rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
      tcNo: { label: '', key: '' || '', id: '' },
      tcOldNo: "",
      assetClassification: {
        key: "option1",
        id: 1,
        label: "Asset",
        isloanerasset: false,
      }, //setting the default value for asset classification when rentalStatus is No
      financeAssetNo: "",
      assetDescription: "",
      typecode: "",
      isTCField: false, // set isTCField to false when clearing the TC lookup field
      typeCodeDescription: { label: '', value: '' },
      locationName: { label: '', value: '' },
      locationNo: "",
      userDepartment: "",
      departmentDescription: "",
      criticality: "",
      workGroup: "",
      ppmRequired: { label: "Yes", key: "option1", default: true }, //setting the default value
      ppmStatus: { label: "In House", key: "option2", id: 2, isvisible: true }, //setting the default value
      parentAssestNo: "",
      description: "",
      reason: "",
      isauthorized: false,
      assetValue: "",
      oldAssetNo: "",
      id: "",
      medicalequipmentcategory: { label: "", value: "", id: "" }
    };
    setBasicDetailsdata((prev) => ({ ...prev, ...intialBaiscDetails }));
    const initailAssetSpecification = {
      make: "",
      brand: "",
      model: "",
      serialNo: "",
      version: "",
      engineNo: "",
      chassisNo: "",
      manufacturer: "",
      registrationNo: "",
      capacity: "",
      assetStatus: {
        label: "Functioning ",
        key: "option1",
        default: true,
        id: 1,
      },
      lifeSpan: "",
      depreciationValue: "",
      buildupArea: "",
      footPrint: "",
      landArea: "",
      isDataSetInEditMode: false,
      medicalequipmentcategory: { label: "", value: "", id: "" }
    };


    const initialPurchaseDetails = {
      warrantyStartDate: "",
      warrantyEndDate: "",
      commissioningDate: "",
      warranty: "",
      vendor: "",
      purchaseOrderNo: "",
      purchaseCost: "",
      accessories: "",
      cumulativePartCost: null,
      cumulativeLabourCost: null,
      lastUnscheduledWorkOrder: "",
      lastScheduledWorkOrder: "",
      assetTransferCategory: "",
      purchaseFlag: "",
      assetTransferDepartment: "",
      underWarrenty: false,
      isDataSetInEditMode: false,
      isTCFieldSet: false,
      assetriskcondition: "",
    };

    const initialAttachmentDetails = [];
    const isAssetCreation = purchaseDetails?.isAssetCreation; //this flag for showing the underwarranty
    const mergedPurchaseDetails = {
      ...initialPurchaseDetails,
      isAssetCreation,
    };
    dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
    dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
    dispatch(updateAssetSpecification("UPDATE_ASSET_SPECIFICATION", initailAssetSpecification));
    dispatch(updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails));
    dispatch(clearAttachmentDetails("CLEAR_ATTACHMENT_DETAILS", initialAttachmentDetails));
  }

  const [isautoFetchedTcDetails, setIsAutoFetchedTCDetails] = useState(false);

  const autofetchTCDetails = (value) => {
    const { id, assetcategory, assetcategoryid, testingcommissionno, serviceid, serviceDesc, vendorid, vendorname,
      vendorcode, typecodeid, typecode, typecodeDesc, workgroupid, workgroup, wgdesc, assetdesc, testingcommissionstartdate,
      model, serialno, userlocationid, purchaseprice, financeassetno, isunderwarranty, warrantystartdate, warrantyexpirydate,
      lifespan, testingcommissioncompletedate, remarks, chassisno, purchaseorderno, registerno, manufacturer, istestpassed,
    } = value;
    //set the related fields to Asset Basic Details
    // default values for basic details
    const intialBaiscDetails = {
      rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
      tcNo: { label: testingcommissionno, key: testingcommissionno || '', id: id },
      tcOldNo: "",
      assetClassification: {
        key: "option1",
        id: 1,
        label: "Asset",
        isloanerasset: false,
      }, //setting the default value for asset classification when rentalStatus is No
      financeAssetNo: financeassetno || "",
      assetDescription: assetdesc || "",
      typecode: "",
      isTCField: true,
      typeCodeDescription: { id: typecodeid, label: `${typecode} - ${typecodeDesc}`, value: typecodeDesc, desc: typecodeDesc } || { label: '', value: '' },
      locationName: userlocationid !== '00000000-0000-0000-0000-000000000000' ? basicDetailsOptions?.locationNameOptions?.find((item) => item?.id === userlocationid) : { label: '', value: '' },
      locationNo: "",
      userDepartment: "",
      departmentDescription: "",
      criticality: "", //need to map once the api fetches criticality
      workGroup: { ...basicDetailsOptions?.workGroupOptions?.find((item) => item?.id === workgroupid) } || "",
      ppmRequired: { label: "Yes", key: "option1", default: true }, //setting the default value
      ppmStatus: { label: "In House", key: "option2", id: 2, isvisible: true }, //setting the default value
      parentAssestNo: "",
      description: "",
      reason: "",
      isauthorized: false,
      assetValue: "",
      oldAssetNo: "",
      id: "",
      medicalequipmentcategory: { label: "", value: "", id: "" }
    };
    setBasicDetailsdata({ ...intialBaiscDetails });
    const initailAssetSpecification = {
      make: "",
      brand: "",
      model: model || "",
      serialNo: serialno || "",
      version: "",
      engineNo: "",
      chassisNo: chassisno || "",
      manufacturer: manufacturer || "",
      registrationNo: registerno || "",
      capacity: "",
      assetStatus: {
        label: "Functioning ",
        key: "option1",
        default: true,
        id: 1,
      },
      lifeSpan: lifespan || "",
      depreciationValue: "",
      buildupArea: "",
      footPrint: "",
      landArea: "",
      isDataSetInEditMode: false,
      medicalequipmentcategory: { label: "", value: "", id: "" },
    };


    const initialPurchaseDetails = {
      warrantyStartDate: warrantystartdate ? dayjs(warrantystartdate).format("YYYY-MM-DDTHH:mm:ss") : "",
      warrantyEndDate: warrantyexpirydate ? dayjs(warrantyexpirydate).format("YYYY-MM-DDTHH:mm:ss") : "",
      // commissioningDate: testingcommissioncompletedate ? dayjs(testingcommissioncompletedate).format("YYYY-MM-DDTHH:mm:ss") : "",
      commissioningDate: warrantystartdate ? dayjs(warrantystartdate).format("YYYY-MM-DDTHH:mm:ss") : "",
      warranty: "",
      vendor: { id: vendorid ? vendorid : "", label: vendorname || "" } || "",
      purchaseOrderNo: purchaseorderno || "",
      purchaseCost: purchaseprice || "",
      accessories: "",
      cumulativePartCost: null,
      cumulativeLabourCost: null,
      lastUnscheduledWorkOrder: "",
      lastScheduledWorkOrder: "",
      assetTransferCategory: "",
      purchaseFlag: "",
      assetTransferDepartment: "",
      underWarrenty: isunderwarranty || false,
      isDataSetInEditMode: false,
      isTCFieldSet: true,
    };

    const initialAttachmentDetails = [];
    const isAssetCreation = purchaseDetails?.isAssetCreation; //this flag for showing the underwarranty
    const mergedPurchaseDetails = {
      ...initialPurchaseDetails,
      isAssetCreation,
    };
    dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
    dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
    dispatch(updateAssetSpecification("UPDATE_ASSET_SPECIFICATION", initailAssetSpecification));
    dispatch(updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails));
    dispatch(clearAttachmentDetails("CLEAR_ATTACHMENT_DETAILS", initialAttachmentDetails));
    setIsAutoFetchedTCDetails(true);
  };

  //common onChange function to handle all type of input values
  const handleOnChange = (value, name, isMandatoryField) => {

    if (name === 'tcNo') {
      if (value?.id) {
        autofetchTCDetails(value);
      } else {
        if (isautoFetchedTcDetails) {
          clearAutoFetchedTCDetails();
          setIsAutoFetchedTCDetails(false);
        }
      }
    }

    // Handle the change event with the name and value
    setBasicDetailsdata((previousValue) => {
      if (name !== 'locationName') {
        return {
          ...previousValue,
          [name]: value
        }
      } else {
        return {
          ...previousValue,
          locationNo: value?.id ? value : '',
          locationName: { ...value, label: value?.desc ? value?.desc : '' }
        }
      }
    });


    if (name === "typeCodeDescription") {
      setBasicDetailsdata((previousValue) => {
        return {
          ...previousValue,
          typeCodeDescription: { ...value, label: value?.desc ? value?.desc : '' }
        }
      })
    }

    //clear parent asset no if asset classification is changed
    if (name === "assetClassification") {
      if (value?.id) {
        setParentAssetNo(value?.id);
      } else {
        setParentAssetNo('');
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          parentAssetOptions: [],
          typeCodeDescriptionOptions: []
        }));
      }
      setBasicDetailsdata((previousValue) => {
        return {
          ...previousValue,
          parentAssestNo: { label: "", id: "", value: "" },
          typeCodeDescription: { label: "", id: "", value: "" }
        }
      });
    }

    if (name === "workGroup") {
      setBasicDetailsdata((previousValue) => {
        return {
          ...previousValue,
          workGroup: { ...value, label: value?.code }
        }
      })
    }

    if (name === 'rentalStatus') {
      if (value?.label === 'Yes') {
        setBasicDetailsdata((previousValue) => {
          return {
            ...previousValue,
            assetClassification: '',
            parentAssestNo: { label: "", id: "", value: "" },
            typeCodeDescription: { label: "", id: "", value: "" },
          }
        });
        //set parent asset no options to empty when rental status changes
        setParentAssetNo('');
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          parentAssetOptions: [],
          typeCodeDescriptionOptions: []
        }));
      }
      if (value?.label === 'No') {
        setBasicDetailsdata((previousValue) => {
          return {
            ...previousValue,
            assetClassification: '',
            parentAssestNo: { label: "", id: "", value: "" },
            typeCodeDescription: { label: "", id: "", value: "" },
          }
        });
        //set parent asset no options and parent asset no to empty when rental status changes
        setParentAssetNo('');
        setBasicDetailsOptions((prevOptions) => ({
          ...prevOptions,
          parentAssetOptions: [],
          typeCodeDescriptionOptions: [],
        }));
      }
      setBasicDetailsdata((previousValue) => {
        return {
          ...previousValue,
          parentAssestNo: { label: "", id: "", value: "" },
          typeCodeDescription: { label: "", id: "", value: "" },
        }
      })
    }

    if (name === 'parentAssestNo') {
      if (!value) {
        setBasicDetailsdata((previousValue) => {
          return {
            ...previousValue,
            description: ''
          }
        })
      }
      setBasicDetailsdata((previousValue) => {
        return {
          ...previousValue,
          parentAssestNo: { ...value, label: value?.code ? value?.code : '' }
        }
      })

    }


    if (isMandatoryField) {
      if (name === 'ppmRequired') { //for all other fileds setting the valueFilled property to true for madatory field in redux
        if (value?.label === 'Yes') {
          setBasicDetailsdata((previousValue) => {
            return {
              ...previousValue,
              reason: '',
              ppmStatus: { label: "In House", key: "option2", id: 2, isvisible: true }
            }
          });
          setError((prev) => {
            return {
              ...prev,
              reason: false
            }
          });
          setErrorMessage((prev) => {
            return {
              ...prev,
              reason: ''
            }
          })
        } else if (value?.label === 'No') {
          setBasicDetailsdata((previousValue) => {
            return {
              ...previousValue,
              reason: '',
              ppmStatus: { label: "N/A", key: "option2", id: 3, isvisible: true }
            }
          })
        }
      }
      //make the error flag to false once user enters value
      setError((prev) => {
        const updatedError = {
          ...prev,
          [name]: false
        };

        const isAllFalse = Object.values(updatedError).every((value) => value === false);

        if (isAllFalse) {
          setIsFilledAllMandatoryField(false);
        }

        return updatedError;
      });
      //clear the error message once the user enters value
      setErrorMessage((prev) => (
        {
          ...prev,
          [name]: ''
        }
      ))
    }
    if (name === 'tcNo' || name === 'typeCodeDescription' || name === 'locationName' || name === 'parentAssestNo') {
      if (!value?.label) {
        setIsDataChanged(false);
        setBasicDetailsdata((previousValue) => {
          return {
            ...previousValue,
            [name]: ""
          }
        })
      }
    } else {
      setIsDataChanged(true);
    }
    if (isMandatoryField) {
      if (name === 'assetDescription' || name === 'reason') {
        if (value) {
          setError((prev) => ({ ...prev, [name]: false }));
          setErrorMessage((prev) => ({ ...prev, [name]: "" }));
        }
        if (!value || utils.validateTextField(value)) {
          setError((prev) => ({ ...prev, [name]: false }));
          setErrorMessage((prev) => ({ ...prev, [name]: "" }));
        } else if (!utils.validateTextField(value)) {
          setError((prev) => ({ ...prev, [name]: true }));
          setErrorMessage((prev) => ({ ...prev, [name]: validations.textfield, }));
        }
      }
    }
  };

  //function to update the mandatory fileds for assestSpecification and purchaseDetails
  const hanldeManditoryFieldforAllOtherPages = () => {
    //set the mandatory fileds for AssetSpecification based on rentalStatus and assetClassification choosen
    if (basicDetailsdata.rentalStatus?.label === "No") {
      //for assetSpecification
      let allRequiredFieldsForAssetSpecification = assetSpecificationMandatoryFields.filter((item) => item.name !== 'lifeSpan');
      let lifeSpan = assetSpecificationMandatoryFields.find((item) => item.name === 'lifeSpan')
      let arraySampleForAssetSpecification;
      let allRequiredFieldsSample;;
      //for PurchaseWarrenty
      let arraySampleForPurchaseWarrenty;
      let allRequiredFieldsForPurchaseWarrenty = purchaseWarrentyMandatoryFields;
      if ((basicDetailsdata.assetClassification?.label === "Asset" || basicDetailsdata.assetClassification?.label === "System")) {
        if (basicDetailsdata.assetClassification?.label === "System") {
          //for system set the isVisible to false for all the fileds except for lifeSpan 
          allRequiredFieldsSample = allRequiredFieldsForAssetSpecification.map((item) => {
            return {
              ...item,
              isVisible: false
            }
          });
        } else {
          allRequiredFieldsSample = assetSpecificationMandatoryFields.map((item) => {
            return {
              ...item,
              isVisible: true
            }
          })
        }
        //for assetSpecification
        lifeSpan = { ...lifeSpan, isVisible: true } //lifeSpan is mandatory only when classfication is Asset or System
        arraySampleForAssetSpecification = basicDetailsdata.assetClassification?.label === "System" ? [...allRequiredFieldsSample, lifeSpan] : [...allRequiredFieldsSample];
        //for PurchaseWarrenty
        const purchaseWarrentFields = allRequiredFieldsForPurchaseWarrenty.map((item) => ({ ...item, isVisible: true }));
        const removeAssetTransferField = purchaseWarrentFields.filter((item) => item.name !== 'assetTransferDepartment');
        const addAssetTransferField = purchaseWarrentFields?.filter((item) => item.name === 'assetTransferDepartment');
        const setAssetTransferIsVisible = addAssetTransferField?.map((item) => ({ ...item, isVisible: false }));
        arraySampleForPurchaseWarrenty = [...removeAssetTransferField, ...setAssetTransferIsVisible];
        //make vendor madatory only when classfication is Asset or System
        arraySampleForPurchaseWarrenty?.forEach((item) => {
          if (item.name === 'vendor') {
            item.isVisible = true
          }
        })
      } else {
        //for other classifications like building and locaiton set isVisible to false
        //for assetSpecification
        allRequiredFieldsForAssetSpecification = allRequiredFieldsForAssetSpecification.map((item) => {
          return {
            ...item,
            isVisible: false,
          }
        }); //set isVisible to false for other classifications like building and locaiton set isVisible to false
        lifeSpan = { type: "Life Span", valueFilled: false, name: 'lifeSpan', isVisible: false }
        arraySampleForAssetSpecification = [...allRequiredFieldsForAssetSpecification, lifeSpan]
        //for PurchaseWarrenty
        arraySampleForPurchaseWarrenty = allRequiredFieldsForPurchaseWarrenty.map((item) => ({ ...item, isVisible: false }));
      }
      //update assetSpecification mandatory fields in redux
      dispatch(
        mandatoryFields(
          arraySampleForAssetSpecification,
          "UPDATE_ASSET_SPECIFICATION_MANDATORY_FIELDS"
        )
      );
      //update purchaseWarranty mandatory fields in redux   
      dispatch(
        mandatoryFields(
          arraySampleForPurchaseWarrenty,
          "UPDATE_PURCHASE_DETAILS_MANDATORY_FIELDS"
        )
      );
    } else {
      //for rentalStatus is choosen 'Yes' then set all fileds to mandatory fields only for assetSpecification
      let allRequiredFieldsForAssetSpecification = assetSpecificationMandatoryFields;
      let arraySampleForAssetSpecification;
      //for mandatory fields set isVisible to false
      const arrayRemovelifeSpan = allRequiredFieldsForAssetSpecification.filter((item) => item.name !== 'lifeSpan');
      const lifeSpan = { type: "Life Span", valueFilled: false, name: 'lifeSpan', isVisible: false }
      arraySampleForAssetSpecification = arrayRemovelifeSpan.map((item) => ({ ...item, valueFilled: false, isVisible: true }));
      arraySampleForAssetSpecification = [...arraySampleForAssetSpecification, lifeSpan]
      //also remove all the values in assetSpecification
      dispatch(
        mandatoryFields(
          arraySampleForAssetSpecification,
          "UPDATE_ASSET_SPECIFICATION_MANDATORY_FIELDS"
        )
      );
      //if rentalStatus is choosen 'Yes' then set purchase flag is mandatory and all other fileds are set to non-mandatory fields
      let arraySampleForPurchaseWarrenty;
      let allRequiredFieldsForPurchaseWarrenty = purchaseWarrentyMandatoryFields;
      //for non-mandatory fields set isVisible to false
      arraySampleForPurchaseWarrenty = allRequiredFieldsForPurchaseWarrenty.map((item) => ({ ...item, isVisible: false }));

      //ISSUE_NO:566 - if rentalStatus is choosen 'Yes' then set purchase flag is mandatory
      //make purchase flag is mandatory

      //ISSUE_No:654 - if rentalStatus is choosen 'Yes' then set purchase flag is non-mandatory
      //Date:08/08/2024
      arraySampleForPurchaseWarrenty.forEach((item) => {
        if (item?.name === 'purchaseFlag') {
          item.isVisible = false;
        }
      });

      //also remove all the values in purchaseWarrenty
      const initialStateForPurchaseWarrenty = {
        warrantyStartDate: '',
        warrantyEndDate: '',
        commissioningDate: '',
      };
      dispatch(updatePurchaseDetails("UPDATE_PURCHASE_WARRENTY", initialStateForPurchaseWarrenty));
      dispatch(mandatoryFields(arraySampleForPurchaseWarrenty, "UPDATE_PURCHASE_DETAILS_MANDATORY_FIELDS"));
    }
  };

  //function for validation,this function checks only the mandatory fileds by
  // comparing the fileds isVisible and valueFilled form the redux(which is updated during onChange)
  const handleValidationForRequiredFields = () => {
    let isValid = true;
    mandatoryBasicDetails.map((item) => {

      if (item?.name !== 'assetDescription') {
        if (item.isVisible === true && item.valueFilled === false) {
          setError((prev) => ({
            ...prev,
            [item.name]: true,
          }));
          setErrorMessage((prev) => ({
            ...prev,
            [item.name]: `${item.type} is required `,
          }));
          isValid = false;
        }
      } else {
        if (item.isVisible === true && item.valueFilled === false) {
          setError((prev) => ({
            ...prev,
            [item.name]: true,
          }));
          if (errorMessage?.assetDescription === '') { //if already error message is there then don't add it
            setErrorMessage((prev) => ({
              ...prev,
              [item.name]: `${item.type} is required `,
            }));
          }
          isValid = false;
        }
      }
    });
    return isValid;
  };

  const saveFilesToAttachment = async (serviceType, item, assetId) => {
    const femorbemAssetId = serviceType === "FEMS" ? "femassetregisterId" : "bemassetregisterId";
    const payload = {
      id: "",
      filename: item?.filename,
      filesize: item?.filesize,
      filepath: "D:/IFAC-X/UploadFolder",
      [femorbemAssetId]: assetId,
      documenttitle: item?.documenttitle,
      isdeleted: false,
    }
    const femorbem = serviceType === "FEMS" ? "femassetattachments" : "bemassetattachments";
    const config = {
      headers: {
        Authorization: `Bearer ${getAuthToken('id_token')}`,
      },
    };

    try {
      const response = await axios.post(`${assetType}/api/${femorbem}`, { ...payload, id: "" }, config);
      return response?.data;
    } catch (error) {
      console.log('Error in saveFilesToAttachment:', error);
    }
  };

  const saveTCAttachments = async (tcID, assetId) => {
    try {
      if (!tcID) {
        return false; // No tcID provided, return false
      }

      const config = {
        headers: {
          Authorization: `Bearer ${getAuthToken('id_token')}`,
        },
      };

      const serviceType = assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS";
      const url = serviceType === "FEMS"
        ? `${FemsGraph}/api/TestingandCommission/GetTestingAttachmentsList/${tcID}`
        : `${BemsGraph}/api/TestingandCommission/GetTestingAttachmentsListbem/${tcID}`;

      const attachment = await axios.get(url, config);

      if (attachment?.data?.length > 0) {
        const savedTCFilesPromises = attachment.data.map(async (item) => {
          try {
            await saveFilesToAttachment(serviceType, item, assetId);
          } catch (error) {
            console.log("Error saving file attachment:", error);
          }
        });

        await Promise.all(savedTCFilesPromises); // Wait for all file uploads
      }

      return true; // Return true after successful completion
    } catch (error) {
      console.log("Error fetching or saving TC attachments:", error);
      return false; // Return false if there's an error
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    //this is done in handleOnChange function but here we are doing it in handleSubmit function (reason:i dont wnat to render all the times)
    hanldeManditoryFieldforAllOtherPages();

    const isValid = handleValidationForRequiredFields();

    const isReasonMandatory = basicDetailsdata?.ppmRequired?.label === "No" ? true : false;
    // Destructure the basicDetailsdata which are Required fields
    const { rentalStatus, assetClassification, assetDescription, typeCodeDescription, locationName, workGroup, ppmRequired, ppmStatus, reason } = basicDetailsdata;
    // Check if the required fields are provided
    if (rentalStatus && assetClassification && assetDescription && typeCodeDescription && locationName && workGroup && ppmRequired && ppmStatus) {
      // Check if the reason field is mandatory and if a value is present
      if (isReasonMandatory && !reason) {
        setIsFilledAllMandatoryField(true);
      } else {
        // Check if the form is valid
        if (isValid) {
          const selectedData = selectedGridData?.values;
          const commonParameters = {
            facilityid: facilityId,
            Assetno: basicDetailsdata?.assetValue,
            assetdesc: basicDetailsdata?.assetDescription,
            isauthorized: selectedGridData?.values?.isauthorized === true ? true : false,
            userlocationid: basicDetailsdata.locationName?.id,
            typecodeid: basicDetailsdata?.typeCodeDescription?.id,
            isloanerasset: basicDetailsdata?.rentalStatus?.label === "Yes" ? true : false,
            isppmrequiredflag: basicDetailsdata?.ppmRequired?.label === "Yes" ? true : false,
            reason: basicDetailsdata?.reason,
            testcommissionoldno: basicDetailsdata?.tcOldNo,
            Oldassetno: basicDetailsdata?.oldAssetNo,
            Finanaceassetno: basicDetailsdata?.financeAssetNo,
            parentassetid: basicDetailsdata?.parentAssestNo !== undefined && basicDetailsdata?.parentAssestNo !== null && basicDetailsdata?.parentAssestNo !== "" ? basicDetailsdata?.parentAssestNo?.id : "",
          }
          const FemsParameter = {
            FemtestingandcommissionId: basicDetailsdata?.tcNo?.id || selectedData?.femtestingandcommissionId, //once the data given map that
            FemassetconditioncategoryId: selectedData?.femassetconditioncategoryId || "", //not in basic details form but required in api
            FemassetclassificationId: basicDetailsdata?.assetClassification?.id,
            FemassetcriticalityId: (basicDetailsdata?.criticality !== undefined && basicDetailsdata?.criticality !== null && basicDetailsdata?.criticality !== "") ?
              basicDetailsdata?.criticality?.id : "",
            FemassetppmstatusId: (basicDetailsdata?.ppmStatus !== undefined && basicDetailsdata?.ppmStatus !== null && basicDetailsdata?.ppmStatus !== "") ?
              basicDetailsdata?.ppmStatus?.id : "",
            FemworkgroupdetailsId: basicDetailsdata?.workGroup?.id,
          }
          const BemsParameter = {
            BemtestingandcommissionId: basicDetailsdata?.tcNo?.id || selectedData?.bemtestingandcommissionId,
            BemassetconditioncategoryId: selectedData?.bemassetconditioncategoryId || "", //not in basic details form but required in api
            BemassetclassificationId: basicDetailsdata?.assetClassification?.id,
            BemassetcriticalityId: (basicDetailsdata?.criticality !== undefined && basicDetailsdata?.criticality !== null && basicDetailsdata?.criticality !== "") ?
              basicDetailsdata?.criticality?.id : "",
            BemassetppmstatusId: (basicDetailsdata?.ppmStatus !== undefined && basicDetailsdata?.ppmStatus !== null && basicDetailsdata?.ppmStatus !== "") ?
              basicDetailsdata?.ppmStatus?.id : "",
            BemworkgroupdetailsId: basicDetailsdata?.workGroup?.id,
            BemmedicalequipmentcategoryId: basicDetailsdata?.medicalequipmentcategory?.id || "",
          }
          const type = assetType === FemsGraph ? "FEMS" : "BEMS";
          let basicDetailsParameters = { ...commonParameters };
          type === "FEMS" ? basicDetailsParameters = { ...commonParameters, ...FemsParameter } : basicDetailsParameters = { ...commonParameters, ...BemsParameter };
          if ((selectedGridData?.isEdit && (selectedGridData?.values?.assetId || selectedGridData?.values?.id)) || basicDetailsdata?.id) {
            // Update asset
            try {
              setIsLoading(true);
              const id = basicDetailsdata?.id || selectedGridData?.values?.assetId || selectedGridData?.values?.id;
              //add modified by parameter only when the user is modifying the asset
              let modifiedBy = "";
              if (!purchaseDetails?.isAssetCreation) {
                modifiedBy = getModifiedBy('modifiedBy');
              }
              const basicDetailsParametersWithId = { ...basicDetailsParameters, id: id, modifiedby: modifiedBy };
              const isEditMode = purchaseDetails?.isAssetCreation ? false : true;
              const changedKeys = AssetRepository.compareObjects(initialBasicDetailsdata, basicDetailsdata);

              const response = await assetCreateUpdateRepository.updateAsset(selectedData, basicDetailsParametersWithId, type, isEditMode, changedKeys);
              const checkFemorBem = type === "FEMS" ? "femworespondtypeId" : "bemworespondtypeId";
              const responseType_payload = {
                [`${checkFemorBem}`]: basicDetailsdata?.ppmStatus?.id || "",
              }
              await AssetRepository.updateresponseTypeID(assetCategoryType, response?.id, responseType_payload);
              if (basicDetailsdata?.ppmRequired?.label === "No") {
                await AssetRepository.updatePPMstatusForTrackerTable(assetCategoryType, response?.id)
                await AssetRepository.updateppmplannerisdeleted(assetCategoryType, id)
              }

              if (type === "BEMS") {
                if (selectedGridData?.values?.isunderwarranty === false) {
                  const previousTypeCodeId = selectedGridData?.values?.typecodeid;
                  const currentTypeCodeId = typeCodeDescription?.id;
                  if (
                    currentTypeCodeId &&
                    currentTypeCodeId !== previousTypeCodeId
                  ) {
                    await AssetRepository.updatePPMTableandTrackerTableTypeocdeid(id);
                  }
                }
              }

              if (response && response.id) {
                dispatch(gridValues({ values: response, isEdit: true, isView: false }));
                dispatch(updateBasicDetails('UPDATE_BASIC_DETAILS', basicDetailsdata)); // Update the basicDetails data in Redux
                setPage("Asset Specification"); // Set to next page
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                setIsLoading(false);

              }
            } catch (error) {
              console.log(error);
              setIsLoading(false);
            }
          } else {
            // Create asset
            setIsLoading(true);
            const assetNo = await generateAssetNo(basicDetailsdata?.assetClassification?.id);
            try {
              if (assetNo) {
                const response = await assetCreateUpdateRepository.createAsset(selectedData, { ...basicDetailsParameters, Assetno: assetNo, processingpercentage: 25 }, type);
                if (response && response.id) {

                  if (basicDetailsdata?.tcNo?.id) {
                    const isSaved = await saveTCAttachments(basicDetailsdata?.tcNo?.id, response?.id);
                    if (isSaved) {
                      const mergedBasicDetails = { ...basicDetailsdata, id: response?.id, assetValue: assetNo };
                      //Note!!! --- here isEdit is set to false because of the useEffect is setting the gridvalues 
                      //for other two pages so that empty values are set
                      dispatch(gridValues({ values: response, isEdit: false, isView: false }));
                      dispatch(updateBasicDetails('UPDATE_BASIC_DETAILS', mergedBasicDetails)); // Update the basicDetails data in Redux
                      setPage("Asset Specification"); // Set to next page
                      dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                    } else {
                      console.log("Error saving TC attachments");
                    }
                  } else {
                    const mergedBasicDetails = { ...basicDetailsdata, id: response?.id, assetValue: assetNo };
                    //Note!!! --- here isEdit is set to false because of the useEffect is setting the gridvalues 
                    //for other two pages so that empty values are set
                    dispatch(gridValues({ values: response, isEdit: false, isView: false }));
                    dispatch(updateBasicDetails('UPDATE_BASIC_DETAILS', mergedBasicDetails)); // Update the basicDetails data in Redux
                    setPage("Asset Specification"); // Set to next page
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));

                  }
                }
                setIsLoading(false);
                navigate(location.pathname, {
                  state: {
                    ...location.state,
                    id: response?.id || "",
                    type: "Edit",
                    timestamp: response?.timestamp || ""
                  }
                });
              }
            } catch (error) {
              console.log(error);
              setIsLoading(false);
            }
          }
        } else {
          setIsFilledAllMandatoryField(false);
        }
      }
    } else {
      setIsFilledAllMandatoryField(true);
    }
  };

  const assetValue = basicDetails?.assetValue || selectedGridData?.values?.assetNo || '';

  return (
    <>
      <PageLoader open={isLoading} />
      <ComponentHeader
        mainHeader={findHeaderContent.mainHeader}
        subHeader={findHeaderContent.subHeader}
        assetvalue={assetValue}
        requiredButton={findHeaderContent.requiredButton}
        statusType={selectedGridData?.values?.isauthorized === true ? 'authorized' : 'unauthorized'}
      />
      <Box mt={{ xs: 1, md: 2 }}>
        <form onSubmit={handleSubmit} style={{ position: "relative" }} data-testid="basic-details-form" noValidate>
          {isFilledAllMandatoryField && <Typography sx={{ color: "error.main" }}>Please Fill All Mandatory Fields(*)</Typography>}
          <Grid container spacing={2}>
            {/* Row 1 */}
            <Grid item xs={12} md={4} sm={6}>
              <CustomSelectInput
                id="rental-status-label"
                label="Rental Status"
                isMandatoryField={true}
                error={error?.rentalStatus}
                errorMessage={errorMessage?.rentalStatus}
                name="rentalStatus"
                value={basicDetailsdata?.rentalStatus || ''}
                options={basicDetailsOptions?.rentalStatusOptions}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextFieldWithSearch
                label="T&C No."
                id="tc-no"
                name="tcNo"
                value={basicDetailsdata?.tcNo || ''}
                options={basicDetailsOptions?.tcNoOptions}
                onChange={handleOnChange}
                disabled={selectedGridData?.isEdit}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="T&C Old No."
                id="tc-old-no"
                name="tcOldNo"
                value={basicDetailsdata?.tcOldNo || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Old Asset No."
                id="old-asset-no"
                name="oldAssetNo"
                value={basicDetailsdata?.oldAssetNo || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomSelectInput
                id="asset-classification-label"
                label="Asset Classification"
                isMandatoryField={true}
                error={error?.assetClassification}
                errorMessage={errorMessage?.assetClassification}
                name="assetClassification"
                value={basicDetailsdata?.assetClassification || ''}
                options={
                  basicDetailsdata.rentalStatus?.label === "No"
                    ? basicDetailsOptions?.assetClassificationOptions?.filter((option, index) => option.isloanerasset === false)
                    : basicDetailsOptions?.assetClassificationOptions?.filter((option, index) => option.isloanerasset === true)
                }
                onChange={handleOnChange}
              />
            </Grid>
            {/* Row 2 */}
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Finance Asset No."
                id="finance-asset-no"
                name="financeAssetNo"
                value={basicDetailsdata?.financeAssetNo || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Asset Description"
                id="asset-description"
                name="assetDescription"
                isMandatoryField={true}
                error={error?.assetDescription}
                errorMessage={errorMessage?.assetDescription}
                value={basicDetailsdata?.assetDescription || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextFieldWithSearch
                label="Type Code Description"
                id="type-code-description"
                name="typeCodeDescription"
                isMandatoryField={true}
                error={error?.typeCodeDescription}
                errorMessage={errorMessage?.typeCodeDescription}
                value={basicDetailsdata?.typeCodeDescription || ''}
                options={basicDetailsOptions?.typeCodeDescriptionOptions}
                onChange={handleOnChange}
              />
            </Grid>
            {/* Row 3 */}
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Type Code"
                disabled={true}
                placeholder={''}
                id="type-code"
                name="typecode"
                value={basicDetailsdata?.typeCodeDescription?.value || ''}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Location Code"
                id="location-no"
                name="locationNo"
                disabled={true}
                placeholder={''}
                value={basicDetailsdata?.locationName?.value || ''}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextFieldWithSearch
                label="Location Name"
                id="location-name"
                name="locationName"
                error={error?.locationName}
                errorMessage={errorMessage?.locationName}
                isMandatoryField={true}
                options={basicDetailsOptions?.locationNameOptions}
                value={basicDetailsdata?.locationName || ''}
                onChange={handleOnChange}
              />
            </Grid>
            {/* Row 4 */}
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Department Code"
                id="user-department"
                name="userDepartment"
                disabled={true}
                placeholder={''}
                value={basicDetailsdata?.locationName?.userDepartment || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Department Description"
                id="department-description"
                name="departmentDescription"
                disabled={true}
                placeholder={''}
                value={basicDetailsdata?.locationName?.departmentDescription || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomSelectInput
                id="criticality"
                label="Criticality"
                name="criticality"
                value={basicDetailsdata?.criticality || ''}
                options={basicDetailsOptions?.criticalityOptions}
                onChange={handleOnChange}
              />
            </Grid>
            {/* Row 5 */}
            <Grid item xs={12} md={4} sm={6}>
              <CustomSelectInput
                id="work-group"
                label="Work Group"
                isMandatoryField={true}
                error={error?.workGroup}
                errorMessage={errorMessage?.workGroup}
                name="workGroup"
                value={basicDetailsdata?.workGroup || ''}
                options={basicDetailsOptions?.workGroupOptions}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomSelectInput
                id="ppm-required"
                label="PPM Required"
                isMandatoryField={true}
                error={error?.ppmRequired}
                errorMessage={errorMessage?.ppmRequired}
                name="ppmRequired"
                value={basicDetailsdata?.ppmRequired || ''}
                options={basicDetailsOptions?.ppmRequiredOptions}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6}>
              <CustomSelectInput
                id="ppm-status"
                label="PPM Status"
                isMandatoryField={true}
                error={error?.ppmStatus}
                errorMessage={errorMessage?.ppmStatus}
                name="ppmStatus"
                value={basicDetailsdata?.ppmStatus || ''}
                options={basicDetailsOptions?.ppmStatusOptions}
                onChange={handleOnChange}
                disabled={basicDetailsdata?.ppmRequired?.label === "No" ? true : false}
              />
            </Grid>
            {/* Row 6 */}
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextFieldWithSearch
                label="Parent Asset No."
                id="parent-asset-no"
                name="parentAssestNo"
                value={basicDetailsdata?.parentAssestNo || ''}
                options={basicDetailsOptions?.parentAssetOptions}
                onChange={handleOnChange}
              />
            </Grid>
            {assetCategoryType === "/assetsBEM" && (
              <Grid item xs={12} md={4} sm={6}>
                <CustomTextFieldWithSearch
                  label="Medical Equipment Category"
                  id="medical-equipment-category"
                  name="medicalequipmentcategory"
                  error={error?.medicalequipmentcategory}
                  errorMessage={errorMessage?.medicalequipmentcategory}
                  options={basicDetailsOptions?.medicalEquipmentCategoryOptions}
                  value={basicDetailsdata?.medicalequipmentcategory || ''}
                  onChange={handleOnChange}
                  isMandatoryField={true}
                />
              </Grid>
            )}
            <Grid item xs={12} md={4} sm={6}>
              <CustomTextField
                label="Description"
                id="description"
                name="description"
                disabled={true}
                placeholder={''}
                value={basicDetailsdata?.parentAssestNo?.assetdesc || ''}
                onChange={handleOnChange}
              />
            </Grid>
            <Grid item xs={12} md={assetCategoryType === "/assetsBEM" ? 4 : 8} sm={6}>
              <CustomTextField
                label="Reason"
                id="reason"
                name="reason"
                error={error?.reason}
                errorMessage={errorMessage?.reason}
                disabled={basicDetailsdata?.ppmRequired?.label === "No" ? false : true}
                placeholder={basicDetailsdata?.ppmRequired?.label === "No" ? 'Please Enter' : ''}
                isMandatoryField={basicDetailsdata?.ppmRequired?.label === "No"}
                value={basicDetailsdata?.reason || ''}
                onChange={handleOnChange}
              />
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "flex-end" },
              mt: 3,
            }}
          >
            <BottomButtons isDataChanged={isDataChanged} page={page} buttonAttributes={buttonAttributes} disableContineButton={isLoading} />
          </Box>
        </form>
      </Box>
    </>
  );
};
export default BasicDetails;
